/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useState } from "react";

const countries = [
    { value: "Sweden", label: "Sweden", icon: '/sweden.svg' },
    { value: "France", label: "France", icon: '/france.svg' }
];

const CountryView = ({ country, onClick }) => (
    <a key={country.value} className="navbar-item p-0" onClick={onClick}>
        <figure className="image is-24x24">
            <img src={country.icon} alt={country.label} />
        </figure>
    </a>
);

const MarketSelector = ({ country, onChange }) => {
    const [activeCountry, setActiveCountry] = useState(countries[0]);

    const onCountryClick = (c) => {
        setActiveCountry(c);

        if (onChange) {
            onChange(c.value);
        }
    }

    useEffect(() => {
        const result = countries.find((c) => c.value === country);
        setActiveCountry(result);
    }, [country]);

    return (
        <div className="navbar-item has-dropdown is-hoverable is-small">
            <a className="navbar-link p-0">
                <figure className="image is-24x24">
                    <img src={activeCountry.icon} alt={activeCountry.label} />
                </figure>
            </a>

            <div className="navbar-dropdown is-small">
                {countries.map((c) => (
                    c.value === activeCountry.value ? '' :
                        <CountryView key={c.value} country={c} onClick={() => onCountryClick(c)} />
                ))}
            </div>
        </div >
    );
}

export { MarketSelector };
